/**
 * The forecast in a day's header — `docs/activity.md` §6.9 (Aaron, point 5;
 * D17: the National Weather Service).
 *
 * The icon is worked out once, by the job, from the daytime period's own words
 * (`shortForecast`); never shown as words — the header carries the icon, the
 * high, the low and the chance of rain, and the words are only the icon's
 * `title` for a screen reader.
 */
export const WEATHER_ICONS = ['sun', 'part', 'cloud', 'rain', 'snow', 'storm', 'fog'];
/** The icon's colour (§6.9). */
export const WEATHER_COLOURS = {
    sun: '#c98a1e',
    part: '#b0731a',
    cloud: '#6f6e68',
    rain: '#2b66a8',
    storm: '#2b66a8',
    snow: '#5b6fb5',
    fog: '#9c9a92',
};
/** What a screen reader hears for each. */
export const WEATHER_TITLES = {
    sun: 'Sunny',
    part: 'Partly sunny',
    cloud: 'Cloudy',
    rain: 'Rain',
    storm: 'Thunderstorms',
    snow: 'Snow',
    fog: 'Fog',
};
/**
 * NWS's *shortForecast* to an icon: the first match in order of severity —
 * storm, snow, rain, fog, cloud, part, sun — so *Chance Rain Showers then
 * Partly Sunny* is rain, and *Mostly Cloudy* is cloud before *Sunny* can match.
 */
export function forecastIcon(shortForecast) {
    const words = shortForecast.toLowerCase();
    if (/thunder/.test(words))
        return 'storm';
    if (/snow|flurr|sleet|freezing|ice|wintry/.test(words))
        return 'snow';
    if (/rain|shower|drizzle/.test(words))
        return 'rain';
    if (/fog|haze|smoke|mist/.test(words))
        return 'fog';
    if (/mostly cloudy|cloudy|overcast/.test(words) && !/partly cloudy/.test(words))
        return 'cloud';
    if (/partly|mostly sunny/.test(words))
        return 'part';
    return 'sun';
}
/** The rain chance turns blue at 30 % (§6.9). */
export const RAIN_BLUE_FROM = 30;
//# sourceMappingURL=weather.js.map